import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import moment from "moment";
import { useForm } from "react-hook-form";
import {
  useGetSmartFormsQuery,
  usePrintPatientScreenMutation,
} from "../../../services/screeningServices";
import { shareDataApi } from "../../../services/shareDataService";
import { getBaseUrl } from "../../../helper";
import { InputField } from "../../../components/reactHookFormFields/inputField";
import { ReactSelectField } from "../../../components/reactHookFormFields/selectField";
import { AppListing } from "../../../components/AppListing/Listing.view";
import MainPageDialog from "../../../components/dialog";
import FullScreenLoader from "../../../components/FullScreenLoader";

const AttachScreeningList = ({ shareDataDetail, selectedChat }) => {
  const { authToken } = useSelector(
    ({ auth }) => ({
      authToken: auth && auth.authToken,
    }),
    shallowEqual
  );
  const [loading, setLoading] = useState(false);
  const { control, handleSubmit } = useForm();
  const [generalData, setGeneralData] = useState([]);
  const [screeningData, setScreeningData] = useState([]);
  const [additionalGeneralData, setAdditionalGeneralData] = useState([]);
  const [generalSelected, setGeneralSelected] = useState([]);
  const [screeningSelected, setScreeningSelected] = useState([]);
  const [additionalGeneralSelected, setAdditionalGeneralSelected] = useState(
    []
  );
  const [payload, setPayload] = useState({});
  //   const {
  //     isLoading: loadingFormList,
  //     data: formList,
  //     isFetching,
  //   } = useGetSmartFormsQuery({
  //     type: "screening",
  //     // patient_age_in_days: moment().diff(selectedPatient?.Patient?.DOB, "days"),
  //     pid: selectedChat?.pid,
  //   });
  const [printPatientScreen] = usePrintPatientScreenMutation();
  const [attachScreeningDataList] =
    shareDataApi?.endpoints?.attachScreeningDataList?.useLazyQuery();
  const printHandler = (data) => {
    setLoading(true);
    printPatientScreen({ id: data?.id }).then((res) => {
      setLoading(false);
      window.open(
        `${getBaseUrl()}/efax/read_document/?file_name=${
          res?.data?.response?.data?.uuid
        }&token=${authToken}&tz=${new Date().getTimezoneOffset()}`
      );
    });
  };
  const generalCols = [
    {
      colWidth: 2,
      key: "title",
    },
    {
      colWidth: 2,
      getData: (data) => {
        return "Specialties not attached";
      },
    },
    {
      colWidth: 2,
      getData: (data) => {
        return "-";
      },
    },
    {
      colWidth: 2,
      key: "created_by_name",
    },
    {
      colWidth: 2,
      getData: (data) => {
        return (
          <div className="flex">
            {moment(data?.modified).format("MM/DD/YYYY")}{" "}
            <div
              className="ml-10 bg-bgGreen px-3 py-1 text-white"
              onClick={() => printHandler(data)}
            >
              Print
            </div>
          </div>
        );
      },
    },
  ];
  // file_name=${uid}&token=${authToken}&tz=${new Date().getTimezoneOffset()}
  useEffect(() => {
    const fetchScreeningData = async () => {
      setLoading(true);
      const res = await attachScreeningDataList({
        ...payload,
        pid: selectedChat?.pid,
        skip_encounter: true,
      });
      setLoading(false);

      if (res?.data?.response?.code === 0) {
        setGeneralData(res?.data?.response?.data?.General || []);
        setScreeningData(res?.data?.response?.data?.Screening || []);
        setAdditionalGeneralData(res?.data?.response?.data?.general || []);
      }
    };

    fetchScreeningData();
  }, [attachScreeningDataList, selectedChat?.pid, payload]);
  const searchHandler = (data) => {
    let payload = {
      ...data,
      form_title: data?.form_title?.title,
      form_type: data?.form_type?.label,
      specialities: data?.specialities?.map((v, k) => v?.id)?.join(","),
    };
    setPayload(payload);
  };
  return (
    <>
      <MainPageDialog
        title="Attach Screenings"
        footer={true}
        footerList={[
          {
            title: "Attach",
            type: "save",
            action: () => {
              shareDataDetail?.attachHandler([
                ...generalSelected,
                ...screeningSelected,
                ...additionalGeneralSelected,
              ]);
            },
          },
          {
            title: "Cancel",
            type: "cancel",
            action: () => {
              shareDataDetail?.closeDialog();
            },
          },
        ]}
        onCancelHandler={() => shareDataDetail?.closeDialog()}
      >
        {loading && <FullScreenLoader />}

        <div className="grid grid-cols-6 gap-3 mt-3">
          <InputField name="title" control={control} title="Title" />
          {/* <div className="col-span-2">
            <SpecialtySearch
              showLabel="label"
              name="specialities"
              control={control}
              title="Speciality"
              isMulti={true}
            />
          </div> */}
          <div>
            <ReactSelectField
              control={control}
              title="Type"
              name="form_type"
              optionData={[
                { label: "General" },
                { label: "ROS" },
                { label: "PE" },
                { label: "ASQ" },
              ]}
            />
          </div>
          {/* <ReactSelectField
            optionData={formList}
            title="Screening Form"
            showLabel="title"
            name="form_title"
            control={control}
          /> */}
          <div>
            <button
              className="ml-2 bg-bgGreen text-white w-20 text-center py-2 rounded"
              onClick={handleSubmit(searchHandler)}
            >
              Search
            </button>
          </div>
        </div>
        <div className="mt-5">
          <div className="bg-teal1000 grid grid-cols-6 overflow-x-auto px-5 py-2 table-auto text-left w-full text-white rounded-t-md">
            <div className="pl-2">Form Title</div>
            <div className="pl-4">Screening Form</div>
            <div className="pl-4">Speciality</div>
            <div className="pl-2">Shared</div>
            <div className="pl-6">Created By</div>
            <div className="pl-6">Last Modified</div>
          </div>

          {generalData?.length > 0 && (
            <AppListing
              cols={[
                {
                  colWidth: 2,
                  title: "General",
                  key: "form_title",
                },
                ...generalCols,
              ]}
              selection={true}
              listData={generalData}
              toggleSelectItem={(data) => {
                setGeneralSelected(data);
              }}
            />
          )}

          {screeningData?.length > 0 && (
            <AppListing
              cols={[
                {
                  colWidth: 2,
                  title: "Screening",
                  key: "form_title",
                },
                ...generalCols,
              ]}
              selection={true}
              listData={screeningData}
              toggleSelectItem={(data) => {
                setScreeningSelected(data);
              }}
            />
          )}

          {additionalGeneralData?.length > 0 && (
            <AppListing
              cols={[
                {
                  colWidth: 2,
                  title: "General",
                  key: "form_title",
                },
                ...generalCols,
              ]}
              selection={true}
              listData={additionalGeneralData}
              toggleSelectItem={(data) => {
                setAdditionalGeneralSelected(data);
              }}
            />
          )}
        </div>
      </MainPageDialog>
    </>
  );
};

export default AttachScreeningList;
